module.exports = __webpack_public_path__ + "static/media/icons_Bilan Tendinopathie (Membres inf‚rieurs).14805cad.svg";